import { render } from "./WCOrderTypesAddToCartDropdown.vue?vue&type=template&id=4c81389c&scoped=true"
import script from "./WCOrderTypesAddToCartDropdown.vue?vue&type=script&lang=js"
export * from "./WCOrderTypesAddToCartDropdown.vue?vue&type=script&lang=js"

import "./WCOrderTypesAddToCartDropdown.vue?vue&type=style&index=0&id=4c81389c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c81389c"]])

export default __exports__